import { render, staticRenderFns } from "./OsSheetContent.vue?vue&type=template&id=78510b48&scoped=true"
import script from "./OsSheetContent.vue?vue&type=script&lang=ts"
export * from "./OsSheetContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78510b48",
  null
  
)

export default component.exports